import * as React from 'react';

import { PriceTypeSerializable } from 'com.cogvio.pricemonitor.api';

const PriceTypeConfigurationMap = new Map<PriceTypeSerializable, any>([
	[
		'ex-factory',
		{ shortcut: 'Ex', tooltip: 'Ex-Factory', backgroundClass: 'bg-cBlue-400', opacityClass: 'bg-opacity-10' },
	],
	[
		'ex-factory-with-vat',
		{
			shortcut: 'Ex+V',
			tooltip: 'Ex-Factory with VAT',
			backgroundClass: 'bg-cPurple-300',
			opacityClass: 'bg-opacity-50',
		},
	],
	[
		'wholesale',
		{ shortcut: 'W', tooltip: 'Wholesale', backgroundClass: 'bg-cPurple-300', opacityClass: 'bg-opacity-50' },
	],
	[
		'wholesale-with-vat',
		{
			shortcut: 'W+V',
			tooltip: 'Wholesale with VAT',
			backgroundClass: 'bg-cPurple-300',
			opacityClass: 'bg-opacity-50',
		},
	],
	['retail', { shortcut: 'R', tooltip: 'Retail', backgroundClass: 'bg-cPurple-300', opacityClass: 'bg-opacity-50' }],
	[
		'retail-with-vat',
		{ shortcut: 'R+V', tooltip: 'Retail with VAT', backgroundClass: 'bg-cPurple-300', opacityClass: 'bg-opacity-50' },
	],
]);

const ERPPriceVolumeGrowthPriceTypeIndicator = ({ priceType }: { priceType: PriceTypeSerializable }) => {
	const priceTypeInformation = PriceTypeConfigurationMap.get(priceType);

	return (
		<span
			className={`relative w-5 h-5 inline-block font-body text-labelsmall rounded-full ${priceTypeInformation.backgroundClass} ${priceTypeInformation.opacityClass} group`}
		>
			<span className='block leading-5 text-black text-center'>{priceTypeInformation.shortcut}</span>
			<span className='absolute left-full bottom-0 ml-1 px-1.5 py-1 rounded-sm font-display text-white bg-black text-center whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible'>
				{priceTypeInformation.tooltip}
			</span>
		</span>
	);
};

export default React.memo(ERPPriceVolumeGrowthPriceTypeIndicator);
